/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataCommissionSettlePageItemVo } from './PageDataCommissionSettlePageItemVo';
import {
    PageDataCommissionSettlePageItemVoFromJSON,
    PageDataCommissionSettlePageItemVoFromJSONTyped,
    PageDataCommissionSettlePageItemVoToJSON,
    PageDataCommissionSettlePageItemVoToJSONTyped,
} from './PageDataCommissionSettlePageItemVo';

/**
 * 
 * @export
 * @interface ResponsePageDataCommissionSettlePageItemVo
 */
export interface ResponsePageDataCommissionSettlePageItemVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataCommissionSettlePageItemVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataCommissionSettlePageItemVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataCommissionSettlePageItemVo}
     * @memberof ResponsePageDataCommissionSettlePageItemVo
     */
    data?: PageDataCommissionSettlePageItemVo;
}

/**
 * Check if a given object implements the ResponsePageDataCommissionSettlePageItemVo interface.
 */
export function instanceOfResponsePageDataCommissionSettlePageItemVo(value: object): value is ResponsePageDataCommissionSettlePageItemVo {
    return true;
}

export function ResponsePageDataCommissionSettlePageItemVoFromJSON(json: any): ResponsePageDataCommissionSettlePageItemVo {
    return ResponsePageDataCommissionSettlePageItemVoFromJSONTyped(json, false);
}

export function ResponsePageDataCommissionSettlePageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataCommissionSettlePageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataCommissionSettlePageItemVoFromJSON(json['data']),
    };
}

export function ResponsePageDataCommissionSettlePageItemVoToJSON(json: any): ResponsePageDataCommissionSettlePageItemVo {
    return ResponsePageDataCommissionSettlePageItemVoToJSONTyped(json, false);
}

export function ResponsePageDataCommissionSettlePageItemVoToJSONTyped(value?: ResponsePageDataCommissionSettlePageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataCommissionSettlePageItemVoToJSON(value['data']),
    };
}

